var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"p-2 badge bg-secondary streetName",style:(_vm.color)},[_vm._v(" "+_vm._s(_vm.displayName)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }